/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
/* global fetch */
import React, { useContext, useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// Used for putting Git commit information in HTML meta tag
import GitInfo from "react-git-info/macro";
import MetaTags from "react-meta-tags";

import "./App.css";
import Navbar from "./modules/Navbar/Navbar";
import Footer from "./modules/Footer/Footer";
import ListPage from "./Pages/Listpage/ListPage";
import MainPage from "./Pages/HomePages/MainPage/MainPage";
import VideoProjectPage from "./Pages/Projectpage/VideoProjectPage/VideoProjectPage";
import ShowAllProjectsPage from "./Pages/ShowAllProjectsPage/ShowAllProjectsPage";
import NotFoundPage from "./Pages/NotFoundPage";

// Context
import AuthContextProvider, { AuthContext } from "./context/AuthContext";

// import global constants
import { NOT_AUTHORIZED } from "./constants";
import AddToMyListContextProvider from "./context/AddToMyListContext";

// Get version information from Git commit
const gitInfo = GitInfo();

/* _MAIN APP FUNCTION_____________________________________________ */
function App() {
  const [authenticatedUser, setAuthenticatedUser] = useState({
    auth_state: 0,
    name: "user",
  });
  const [passIDFromProjectPage, setPassIDFromProjectPage] = useState(null);
  const [nurOeffentlichSwitch, setNurOeffentlichSwitch] = useState(false);
  const [uid, setUid] = useState("");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API}/getAuthenticationUid`)
      .then((response) => response.json())
      .then(
        (response) => {
          setAuthenticatedUser(response[0]);
        },
        (error) => {
          console.log(`Fehler Authentifizierung: ${error}`);
        }
      );
  }, []);

  useEffect(() => {
    if (authenticatedUser.auth_state > NOT_AUTHORIZED) {
      fetch(`${process.env.REACT_APP_API}/request_uid`)
        .then((response) => response.text())
        .then(
          (response) => {
            setUid(response);
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }, [authenticatedUser.auth_state]);

  return (
    <Router>
      <MetaTags>
        <meta
          property="version"
          content={`${gitInfo.commit.date} ${gitInfo.commit.shortHash}`}
        />
      </MetaTags>
      <AuthContextProvider>
        <AddToMyListContextProvider>
          <PopulateAuth />
          <div className="App">
            <Navbar
              parentIDCallback={(value) => setPassIDFromProjectPage(value)}
              userIsAuthenticated={authenticatedUser}
              nurOeffentlichSwitchCallback={(value) => setNurOeffentlichSwitch(value)}
              userName={uid}
            />
            <Switch>
              <Route
                path="/mediathek/"
                exact
                render={() => (
                  <MainPage onlyShowPublicProjects={nurOeffentlichSwitch} />
                )}
              />
              <Route
                path="/mediathek/favorites"
                render={() => (
                  <ListPage onlyShowPublicProjects={nurOeffentlichSwitch} />
                )}
              />
              <Route
                path="/mediathek/projectpage/:id"
                render={(props) => (
                  <VideoProjectPage
                    {...props}
                    userIsAuthenticated={authenticatedUser}
                    onlyShowPublicProjects={nurOeffentlichSwitch}
                  />
                )}
              />
              <Route
                path="/mediathek/allesanzeigen/:studiotechnik"
                render={(props) => (
                  <ShowAllProjectsPage
                    {...props}
                    onlyShowPublicProjects={nurOeffentlichSwitch}
                  />
                )}
              />
              <Route
                path="/mediathek/"
                exact
                render={() => (
                  <MainPage onlyShowPublicProjects={nurOeffentlichSwitch} />
                )}
              />
              <Route
                path="/mediathek/favorites"
                render={() => <ListPage />}
              />
              <Route
                path="/mediathek/allesanzeigen/:studiotechnik"
                render={(props) => <ShowAllProjectsPage {...props} />}
              />
              <Route path="/" component={NotFoundPage} />
            </Switch>
            <Footer />
          </div>
        </AddToMyListContextProvider>
      </AuthContextProvider>
    </Router>
  );
}

export default App;

function PopulateAuth() {
  const { authenticatedUser, updateAuthenticatedUser, updateUid } = useContext(
    AuthContext
  );

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API}/getAuthenticationUid`)
      .then((response) => response.json())
      .then(
        (response) => {
          updateAuthenticatedUser(response[0]);
        },
        (error) => {
          console.log(`Fehler Authentifizierung: ${error}`);
        }
      );
  }, []);

  useEffect(() => {
    if (authenticatedUser.auth_state > NOT_AUTHORIZED) {
      fetch(`${process.env.REACT_APP_API}/request_uid`)
        .then((response) => response.text())
        .then(
          (response) => {
            updateUid(response);
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }, [authenticatedUser.auth_state]);

  return null;
}
